<template>
  <Webview>
    <div class="terms_frame">
      <h1>Sonice Notify 隱私政策</h1>
      <p><strong>最近更新日期：2025/XX/XX</strong></p>
      <p>歡迎使用 <strong>Sonice Notify</strong>（以下簡稱「本應用」）。本應用由 <strong>好友電智慧科技股份有限公司</strong>（以下簡稱「我們」）提供。我們重視您的隱私，並致力於保護您的個人資訊。本隱私政策說明我們如何依據台灣 <strong>《個人資料保護法》</strong> 及相關法規，收集、使用、儲存和分享您的資訊。請您詳細閱讀，使用本應用即表示您同意本隱私政策的內容。</p>

      <div class="section">
        <h2>1. 我們如何收集您的個人資料</h2>
        <p>我們僅在 <strong>合法、正當、必要</strong> 的情況下，依照台灣 <strong>《個人資料保護法》</strong> 蒐集您的個人資料，包括但不限於：</p>

        <h3>1.1 您提供的資訊</h3>
        <ul>
          <li><strong>帳號資訊</strong>：當您註冊或登入時，我們可能會收集您的電子郵件地址、使用者名稱或其他必要的帳戶資訊。</li>
          <li><strong>通知設定</strong>：您可自定義通知來源、訊息類型及推播偏好，這些設定將儲存於您的帳號中。</li>
          <li><strong>聯絡資訊</strong>：當您聯繫客服或提交反饋時，我們可能會收集您的聯絡方式及相關對話記錄。</li>
        </ul>

        <h3>1.2 自動收集的資訊</h3>
        <ul>
          <li><strong>設備與應用資訊</strong>：包括您的設備型號、作業系統版本、應用版本、IP 地址等，以優化我們的服務。</li>
          <li><strong>使用數據</strong>：為了改善用戶體驗，我們可能會收集您使用本應用的頻率、功能點擊記錄等匿名數據。</li>
          <li><strong>推播通知紀錄</strong>：當您使用通知功能時，我們可能會收集通知的發送時間、內容類型等資料，以確保服務正常運行。</li>
        </ul>
      </div>

      <div class="section">
        <h2>2. 我們如何使用您的個人資料</h2>
        <p>我們僅在 <strong>合法、正當、符合原始蒐集目的</strong> 的範圍內使用您的個人資料，主要用於以下目的：</p>
        <ul>
          <li>向您發送即時通知並確保通知功能正常運作。</li>
          <li>讓您能夠管理通知來源與設定。</li>
          <li>提供應用程式的最佳化體驗，如錯誤修復、效能提升。</li>
          <li>確保應用的安全性，防止未授權的存取與濫用。</li>
          <li>回應您的客服需求，提供技術支援與問題解決方案。</li>
        </ul>
      </div>

      <div class="section">
        <h2>3. 我們如何分享您的個人資料</h2>
        <p>我們 <strong>不會出售、出租或未經授權共享</strong> 您的個人資訊，但在以下情況下，我們可能會提供您的資訊：</p>
        <ul>
          <li><strong>法律要求</strong>：若因應政府機構、法院命令或相關法律要求，我們可能會提供您的資訊。</li>
          <li><strong>第三方服務提供商</strong>：我們可能會與可信賴的技術合作夥伴（如推播通知服務商）共享必要的資訊，以確保服務正常運作。</li>
          <li><strong>業務轉讓</strong>：如發生合併、收購或資產轉讓，我們可能會將您的資訊轉移給相關公司。</li>
        </ul>
      </div>

      <div class="section">
        <h2>4. 您的個人資料保護權利</h2>
        <p>根據台灣 <strong>《個人資料保護法》</strong>，您對您的個人資料享有以下權利：</p>
        <ol>
          <li>查詢或請求閱覽您的個人資料。</li>
          <li>請求提供您的個人資料副本。</li>
          <li>請求補充、更正您的個人資料。</li>
          <li>請求刪除您的個人資料（在不影響服務基本運作的前提下）。</li>
          <li>請求停止蒐集、處理或利用您的個人資料。</li>
        </ol>
      </div>

      <div class="section">
        <h2>5. 個人資料的儲存與安全</h2>
        <p>我們採取 <strong>適當的技術與管理措施</strong> 來保護您的個人資料。</p>
      </div>

      <div class="section">
        <h2>6. 未成年人隱私保護</h2>
        <p>本應用 <strong>不適用於 13 歲以下的兒童</strong>。</p>
      </div>

      <div class="section">
        <h2>7. 隱私政策的變更</h2>
        <p>我們可能會根據台灣 <strong>《個人資料保護法》</strong> 及業務需求不時更新本隱私政策。</p>
      </div>

      <div class="section">
        <h2>8. 聯絡我們</h2>
        <p><strong>公司名稱</strong>：好友電智慧科技股份有限公司</p>
        <p><strong>電子郵件</strong>：<a href="mailto:Info@sonice-aioe.com">Info@sonice-aioe.com</a></p>
        <p><strong>地址</strong>：新北市三重區重新路一段84號3樓</p>
      </div>
    </div>
  </Webview>
</template>

<script>
export default {

}
</script>

<style>
</style>